const descriptionsInCurriculumsPage = {
  es: {
    initial: `
<strong style="font-size: 1.3em; display: block;">¡Hola! Bienvenid@ a</strong>
<strong style="font-size: 1.9em; display: block; margin-top; line-height: 1.0; : 4px;">LOREI Massage & Wellness</strong>

<div style="display:block; margin-top:10px; line-height:1.6; text-align:center;">

    <div style="font-size:1.8em; margin-bottom:6px;">
    <span class="heartbeat">👇</span>
</div>

    <div><strong>① Selecciona un masaje</strong></div>

    <div><strong>② Completa tu reserva</strong></div>

</div>
`,

    aboutMe: "Soy Lucas Rey, masajista profesional con más de cinco años de experiencia en terapias manuales, complementados por una década de viajes en los que aprendí técnicas de distintas partes del mundo. Mi objetivo es ayudarte a sentirte mejor a través de masajes personalizados que realmente respondan a lo que tu cuerpo necesita. Si lo deseas, también ofrezco un espacio de conversación y escucha, para que cualquier aspecto emocional que influya en tu bienestar pueda ser considerado durante la sesión. Mi enfoque combina la técnica, precisión y un trato genuino, buscando que cada sesión te deje más relajado, con mayor claridad y equilibrio.",

    drawing1: "Ideal para quienes acumulan tensión muscular o mantienen posturas exigentes durante el día. Mediante una presión intensa y maniobras lentas y precisas, este masaje actúa en las capas más profundas del músculo para liberar contracturas, disolver nudos y devolver flexibilidad y movilidad. Apuntate y dale a tu cuerpo un alivio físico real y duradero.",
    drawing2: "Una experiencia sensorial diseñada para reconectar con tu bienestar. Con aceite caliente y aromas personalizados, acompañado de música suave e incienso, se aplican movimientos largos, envolventes y armónicos que calman la mente, suavizan la piel y equilibran la energía corporal. Es una invitación a soltar y disfrutar de un descanso profundo.",
    drawing3: "Pensado para deportistas y personas activas que necesitan liberar la carga muscular después del esfuerzo. A través de una presión firme y maniobras dinámicas, favorece la circulación, elimina la sensación de pesadez y acelera la recuperación muscular. Te ayuda a mantener el cuerpo en forma y bien preparado para el próximo desafío.",

    buttonText: ["Tejido Profundo", "Relajante SPA", "Descarga muscular"],

    extraTags: [
      ["💪"],
      ["🌿"],
      ["🔥"]
    ],

    timeMessage: " Tu tiempo comienza cuando inicia el masaje ",
    extrasMessage: "",
    footerFormText: "RESERVA AQUÍ",

    // ===== PAQUETES PROMOCIONALES (ocultos temporalmente) =====
// promoTitle: "*PAQUETES PROMOCIONALES*",
// promoLine1: "6 meses de vigencia",
// promoLine2: "Transferibles",
    promoTitle: "",
    promoLine1: "",
    promoLine2: "",
    promoLocation: "Actualmente en:",
    mapFooter1: "*Servicio a domicilio sujeto a zonas y distancias.*",
    mapFooter2: "",
    deliveryTitle: "",
    deliveryLine1: "",
    deliveryLine2: "",
    deliveryLine3: "",
    TimeTitle: "",
    oilsTitle: "",
    oils1: "",
    oils2: "",
    oils3: "",
  },

  en: {
  initial: `
<strong style="font-size: 1.3em; display: block;">Hello! Welcome to</strong>
<strong style="font-size: 1.9em; display: block; margin-top; line-height: 1.0; : 4px;">LOREI Massage & Wellness</strong>

<div style="display:block; margin-top:10px; line-height:1.6; text-align:center;">

    <div style="font-size:1.8em; margin-bottom:6px;">
    <span class="heartbeat">👇</span>
</div>

    <div><strong>① Tap a massage</strong></div>

    <div><strong>② Scroll down to book</strong></div>

</div>
`,

  aboutMe: "I’m Lucas Rey, a professional massage therapist with more than five years of experience in manual therapies, complemented by a decade of traveling during which I learned techniques from different parts of the world. My goal is to help you feel better through personalized massages that truly respond to what your body needs. If you wish, I also offer a space for conversation and listening, so that any emotional aspect influencing your well-being can be considered during the session. My approach combines technique, precision, and genuine care, aiming for every session to leave you feeling more relaxed, clear-minded, and balanced.",

  drawing1: "Ideal for those who accumulate muscular tension or maintain demanding postures throughout the day. Through deep pressure and slow, precise movements, this massage works on the deepest muscle layers to release tension, dissolve knots, and restore flexibility and mobility. Treat yourself and give your body real, lasting physical relief.",

  drawing2: "A sensory experience designed to reconnect you with your well-being. Using warm oil and personalized aromas, accompanied by soft music and incense, long, flowing, and harmonious movements are applied to calm the mind, soften the skin, and balance the body's energy. It is an invitation to let go and enjoy deep rest.",

  drawing3: "Designed for athletes and active individuals who need to release muscular tension after physical effort. Through firm pressure and dynamic techniques, it improves circulation, relieves heaviness, and accelerates muscle recovery. It helps keep your body in shape and ready for the next challenge.",

  buttonText: ["Deep Tissue", "Relaxing SPA", "Muscle Recovery"],

  extraTags: [
    ["💪"],
      ["🌿"],
      ["🔥"]
    ],

  timeMessage: " Your session time begins when the massage starts ",

  extrasMessage: "",

  footerFormText: "Complete your intake form before your session. If you have a specific request, such as group sessions, contact me directly via WhatsApp.",

  promoTitle: "",
  promoLine1: "",
  promoLine2: "",
  promoLocation: "Currently in:",

  mapFooter1: "*Home service subject to zones and distance.*",
  mapFooter2: "",

  deliveryTitle: "Service",
  deliveryLine1: "Home Visit",
  deliveryLine2: "",
  deliveryLine3: "",

  TimeTitle: "Duration",

  oilsTitle: "Essential Oils",
  oils1: "Relaxing",
  oils2: "Energizing",
  oils3: "Anti-inflammatory",
},

  it: {
  initial: `
<strong style="font-size: 1.3em; display: block;">Ciao! Benvenut@ a</strong>
<strong style="font-size: 1.9em; display: block; margin-top; line-height: 1.0; : 4px;">LOREI Massage & Wellness</strong>

<div style="display:block; margin-top:10px; line-height:1.6; text-align:center;">

    <div style="font-size:1.8em; margin-bottom:6px;">
    <span class="heartbeat">👇</span>
</div>

    <div><strong>① Tocca un massaggio</strong></div>

    <div><strong>② Scorri verso il basso per prenotare</strong></div>

</div>
`,

  aboutMe: "Sono Lucas Rey, massaggiatore professionista con più di cinque anni di esperienza nelle terapie manuali, arricchiti da un decennio di viaggi durante i quali ho appreso tecniche provenienti da diverse parti del mondo. Il mio obiettivo è aiutarti a stare meglio attraverso massaggi personalizzati che rispondano realmente alle esigenze del tuo corpo. Se lo desideri, offro anche uno spazio di ascolto e conversazione, affinché qualsiasi aspetto emotivo che influenzi il tuo benessere possa essere considerato durante la sessione. Il mio approccio combina tecnica, precisione e attenzione autentica, cercando di farti sentire più rilassat@, lucido/a ed equilibrat@ dopo ogni trattamento.",

  drawing1: "Ideale per chi accumula tensione muscolare o mantiene posture impegnative durante la giornata. Attraverso una pressione intensa e movimenti lenti e precisi, questo massaggio agisce sugli strati più profondi dei muscoli per sciogliere contratture, eliminare nodi e restituire flessibilità e mobilità. Regalati un sollievo fisico reale e duraturo.",

  drawing2: "Un’esperienza sensoriale pensata per riconnetterti con il tuo benessere. Con olio caldo e aromi personalizzati, accompagnati da musica rilassante e incenso, vengono applicati movimenti lunghi, avvolgenti e armoniosi che calmano la mente, ammorbidiscono la pelle ed equilibrano l’energia del corpo. Un invito a lasciarsi andare e godersi un profondo riposo.",

  drawing3: "Pensato per sportivi e persone attive che hanno bisogno di liberare la tensione muscolare dopo lo sforzo fisico. Attraverso una pressione decisa e tecniche dinamiche, favorisce la circolazione, allevia la sensazione di pesantezza e accelera il recupero muscolare. Aiuta a mantenere il corpo in forma e pronto per la prossima sfida.",

  buttonText: ["Tessuto Profondo", "SPA Rilassante", "Recupero Muscolare"],

  extraTags: [
    ["💪"],
      ["🌿"],
      ["🔥"]
    ],

  timeMessage: " Il tuo tempo inizia quando comincia il massaggio ",

  extrasMessage: "",

  footerFormText: "Compila il modulo di ingresso prima della tua sessione. Se hai una richiesta particolare, come trattamenti di gruppo, scrivimi direttamente su WhatsApp.",

  promoTitle: "",
  promoLine1: "",
  promoLine2: "",
  promoLocation: "Attualmente a:",

  mapFooter1: "*Servizio a domicilio soggetto a zone e distanze.*",
  mapFooter2: "",

  deliveryTitle: "Servizio",
  deliveryLine1: "A domicilio",
  deliveryLine2: "",
  deliveryLine3: "",

  TimeTitle: "Durata",

  oilsTitle: "Oli essenziali",
  oils1: "Rilassante",
  oils2: "Energizzante",
  oils3: "Antinfiammatorio",
},


  de: {
  initial: `
<strong style="font-size: 1.3em; display: block;">Witaj! Witamy w</strong>
<strong style="font-size: 1.9em; display: block; margin-top; line-height: 1.0; : 4px;">LOREI Massage & Wellness</strong>

<div style="display:block; margin-top:10px; line-height:1.6; text-align:center;">

    <div style="font-size:1.8em; margin-bottom:6px;">
    <span class="heartbeat">👇</span>
</div>

    <div><strong>① Wybierz masaż</strong></div>

    <div><strong>② Przesuń, aby zarezerwować</strong></div>

</div>
`,

  aboutMe: "Jestem Lucas Rey, profesjonalnym masażystą z ponad pięcioletnim doświadczeniem w terapiach manualnych, uzupełnionym dekadą podróży, podczas których poznawałem techniki z różnych zakątków świata. Moim celem jest pomóc Ci poczuć się lepiej dzięki indywidualnie dopasowanym masażom, które odpowiadają rzeczywistym potrzebom Twojego ciała. Jeśli tego potrzebujesz, oferuję również przestrzeń do rozmowy i uważnego wysłuchania, aby uwzględnić emocjonalne aspekty wpływające na Twoje samopoczucie podczas sesji. Moje podejście łączy technikę, precyzję i autentyczne zaangażowanie, aby każda sesja pozostawiła Cię bardziej zrelaksowanym, spokojniejszym i w lepszej równowadze.",

  drawing1: "Idealny dla osób zmagających się z napięciem mięśniowym lub utrzymujących wymagające pozycje przez cały dzień. Dzięki intensywnemu naciskowi oraz powolnym i precyzyjnym technikom masaż działa na najgłębsze warstwy mięśni, uwalniając przykurcze, rozluźniając napięcia i przywracając elastyczność oraz swobodę ruchu. Zadbaj o swoje ciało i zapewnij mu prawdziwą, długotrwałą ulgę.",

  drawing2: "Doświadczenie stworzone po to, aby na nowo połączyć Cię z dobrym samopoczuciem. Z wykorzystaniem ciepłego olejku i indywidualnie dobranych aromatów, przy delikatnej muzyce i zapachu kadzidła wykonywane są długie, płynne i harmonijne ruchy, które uspokajają umysł, pielęgnują skórę i przywracają równowagę energetyczną organizmu. To zaproszenie do całkowitego odprężenia i głębokiego odpoczynku.",

  drawing3: "Przeznaczony dla sportowców i osób aktywnych, które chcą zredukować napięcie mięśni po wysiłku. Dzięki mocnemu naciskowi i dynamicznym technikom masaż poprawia krążenie, zmniejsza uczucie ciężkości i przyspiesza regenerację mięśni. Pomaga utrzymać ciało w doskonałej kondycji i przygotować je na kolejne wyzwania.",

  buttonText: ["Masaż tkanek głębokich", "Relaksujący SPA", "Regeneracja mięśni"],

  extraTags: [
    ["💪"],
      ["🌿"],
      ["🔥"]
    ],

  timeMessage: " Twój czas rozpoczyna się wraz z rozpoczęciem masażu ",

  extrasMessage: "",

  footerFormText: "ZAREZERWUJ TUTAJ",

  promoTitle: "",
  promoLine1: "",
  promoLine2: "",
  promoLocation: "Obecnie w:",

  mapFooter1: "*Usługa z dojazdem do klienta zależy od strefy i odległości.*",
  mapFooter2: "",

  deliveryTitle: "Service",
  deliveryLine1: "Hausbesuch",
  deliveryLine2: "",
  deliveryLine3: "",

  TimeTitle: "Dauer",

  oilsTitle: "Ätherische Öle",
  oils1: "Entspannend",
  oils2: "Energiegebend",
  oils3: "Entzündungshemmend",
},

  is: {
  initial: `
<strong style="font-size: 1.3em; display: block;">Halló! Velkomin(n) til</strong>
<strong style="font-size: 1.9em; display: block; margin-top; line-height: 1.0; : 4px;">LOREI Massage & Wellness</strong>

<div style="display:block; margin-top:10px; line-height:1.6; text-align:center;">

    <div style="font-size:1.8em; margin-bottom:6px;">
    <span class="heartbeat">👇</span>
</div>

    <div><strong>① Pikkaðu á nudd</strong></div>

    <div><strong>② Skrunaðu niður til að bóka</strong></div>

</div>
`,

  aboutMe: "Ég heiti Lucas Rey og er faglærður nuddari með meira en fimm ára reynslu í handvirkum meðferðum, auk tíu ára ferðalaga þar sem ég lærði aðferðir frá mismunandi heimshlutum. Markmið mitt er að hjálpa þér að líða betur með persónulegu nuddi sem svarar raunverulega þörfum líkamans. Ef þú vilt býð ég einnig upp á rými fyrir samtal og hlustun, þannig að tilfinningalegir þættir sem hafa áhrif á vellíðan þína geti verið teknir með í reikninginn í meðferðinni. Nálgun mín sameinar tækni, nákvæmni og einlæga umhyggju, með það að markmiði að þú farir frá hverri meðferð afslappaðri, skýrari í huga og í betra jafnvægi.",

  drawing1: "Tilvalið fyrir þá sem safna upp vöðvaspennu eða halda krefjandi líkamsstöðu yfir daginn. Með djúpum þrýstingi og hægum, nákvæmum hreyfingum vinnur þetta nudd á dýpstu lög vöðvanna til að losa um spennu, leysa hnúta og endurheimta liðleika og hreyfigetu. Dekraðu við þig og gefðu líkamanum raunverulegan og langvarandi létti.",

  drawing2: "Skynræn upplifun sem er hönnuð til að tengja þig aftur við vellíðan þína. Með volgri olíu og sérvöldum ilmum, ásamt mjúkri tónlist og reykelsi, eru notaðar langar, flæðandi og samræmdar hreyfingar sem róa hugann, mýkja húðina og koma jafnvægi á líkamsorkuna. Þetta er boð um að sleppa takinu og njóta djúprar hvíldar.",

  drawing3: "Hannað fyrir íþróttafólk og virkt fólk sem þarf að losa um vöðvaspennu eftir álag. Með ákveðnum þrýstingi og kraftmiklum aðferðum er blóðrásin örvuð, þyngslatilfinning minnkuð og endurheimt vöðva hraðuð. Hjálpar líkamanum að vera í góðu formi og tilbúnum fyrir næstu áskorun.",

  buttonText: ["Djúpvefja-nudd", "Slakandi SPA", "Vöðvaendur-heimt"],

  extraTags: [
   ["💪"],
      ["🌿"],
      ["🔥"]
    ],

  timeMessage: " Tíminn þinn hefst þegar nuddið byrjar ",

  extrasMessage: "",

  footerFormText: "Fylltu út skráningarformið áður en meðferðin hefst. Ef þú hefur sérstaka beiðni, eins og hópmeðferðir, hafðu samband við mig beint á WhatsApp.",

  promoTitle: "",
  promoLine1: "",
  promoLine2: "",
  promoLocation: "Núna staðsett í:",

  mapFooter1: "*Heimaþjónusta fer eftir svæði og fjarlægð.*",
  mapFooter2: "",

  deliveryTitle: "Þjónusta",
  deliveryLine1: "Heimsókn heim",
  deliveryLine2: "",
  deliveryLine3: "",

  TimeTitle: "Lengd",

  oilsTitle: "Ilmkjarnaolíur",
  oils1: "Slakandi",
  oils2: "Orkugefandi",
  oils3: "Bólgueyðandi",
}
};

export default descriptionsInCurriculumsPage;